import React, { useState, useEffect } from 'react'
import {
  Form,
  Container,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
  Col,
  Card} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { PencilSquare } from 'react-bootstrap-icons'
import EditEnquiryForm from './EditEnquiryForm'
import Cookies from 'js-cookie'
import axios from 'axios'
import { ChatDots } from 'react-bootstrap-icons'
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsPencilFill } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'

const EnquiryForm = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedEnquiry, setSelectedEnquiry] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const initialData = []
  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [statusChanges, setStatusChanges] = useState({})

  const fetchEnquiries = async () => {
    const instituteId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')

    if (!instituteId || !userCookie) return

    try {
      setLoading(true)
      const user = JSON.parse(userCookie)
      const token = user.token

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'institute-Id': Number(instituteId)}

      const response = await axios.get(
        BASE_URL+'/enquiries/all',
        { headers },
      )

      const allData = response.data.data
      const filtered = allData.filter(
        (item) => String(item.institute_id) === String(instituteId),
      )
      setData(filtered)
    } catch (error) {
      console.error('Failed to fetch enquiries:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchEnquiries()
  }, [])

  const [enquiries, setEnquiries] = useState([])
  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    if (!instituteId) {
      setData([])
      setEnquiries([])
      toast.error('No Institute ID found. Cannot fetch courses.')
      return
    }

    ApiEndpoints.getAllEnquiries()
      .then((response) => {
        const allCourses = response.data.data || []
        setData(allCourses)
        setEnquiries(allCourses)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  const filteredData = data
    .filter((item) => item.status !== 'converted') // Exclude converted
    .filter((item) =>
      Object.values(item).some((value) =>
        value !== null && value !== undefined
          ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
          : false,
      ),
    )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  const handleStatusChange = (id, newStatus) => {
    setData((preItems) =>
      preItems.map((item) =>
        item.id === id ? { ...item, status: newStatus } : item,
      ),
    )
  }
  const handleRefresh = async () => {
    setSearch('')
    setCurrentPage(1)
    fetchEnquiries()
  }

  const handleSubmit = async (enquiry) => {
    try {
      const userCookie = Cookies.get('user')
      const token = JSON.parse(userCookie)?.token

      const studentPayload = {
        enquiryId: enquiry.id,
        name: enquiry.name,
        email: enquiry.email,
        phone: enquiry.phone,
        course_id: enquiry.course_id,
        dob: enquiry.dob,
        gender: enquiry.gender,
        address: enquiry.address,
        mother_name: enquiry.mother_name,
        father_name: enquiry.father_name,
        parents_number: enquiry.parents_number,
        institute_id: enquiry.institute_id,
        admission_date: enquiry.admission_date,
        admission_number: enquiry.admission_number,
        roll_number: enquiry.roll_number,
        whatsapp_number: enquiry.whatsapp_number,
        id_proof_number: enquiry.id_proof_number,
        id_proof_type: enquiry.id_proof_type}

      const response = await ApiEndpoints.addStudent(studentPayload, token)

      const studentId = response?.data?.data?.id

      toast.success(response.data.message)

      navigate(`/UpdateStudentEnquiry/${studentId}`, {
        state: { enquiry, status: 'Active' }})
    } catch (error) {
      const errorMessage = error?.response?.data?.message

      if (
        errorMessage &&
        errorMessage.includes('Duplicate entry') &&
        errorMessage.includes('students.email')
      ) {
        console.error('A student with this email already exists.')
      } else {
        toast.error(errorMessage || 'Something went wrong during registration.')
      }

      console.error('Add Student Error:', error)
    }
  }

  const handleReject = async (enquiry) => {
    try {
      const userCookie = Cookies.get('user')
      // const institute_id = Cookies.get('institute_id')

      const user = JSON.parse(userCookie)
      const token = user.token

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        // 'Institute-ID': institute_id,
      }

      const response = await axios.post(
        BASE_URL + `/convert/student/${enquiry.id}`,
        { status: 'rejected' },
        { headers },
      )

      // const response = await ApiEndpoints.addStudent(studentPayload, enquiry.id,
      //   { status: "rejected" },
      //   token
      // )

      setData((prevItems) => prevItems.filter((item) => item.id !== enquiry.id))
      setEnquiries((prevItems) =>
        prevItems.filter((item) => item.id !== enquiry.id),
      )
      setStatusChanges((prev) => {
        const updated = { ...prev }
        delete updated[enquiry.id]
        return updated
      })

      toast.success(response.data.message || 'Enquiry rejected successfully!')
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to reject enquiry.')
      return false
    }
  }


  return (
    <>
      <style>
        {`
          .table td {
            user-select: text;
          }
          .table tbody tr {
            cursor: default;
          }
          /* Status select: keep label clear of the dropdown arrow on mobile cards */
          .enquiry-status-select.form-select {
            padding-right: 2.25rem !important;
            background-position: right 0.65rem center !important;
            background-repeat: no-repeat !important;
            text-overflow: ellipsis;
          }
          .enquiry-status-submit {
            border-radius: 8px;
            font-family: Inter, system-ui, sans-serif;
            font-size: 14px;
            font-weight: 600;
            padding: 0.4rem 1rem;
            min-height: 36px;
            white-space: nowrap;
          }
          /* Desktop: keep Pending select compact (do not stretch) */
          @media screen and (min-width: 40.01em) {
            .enquiry-status-actions {
              display: flex;
              flex-direction: row;
              align-items: center;
              flex-wrap: nowrap;
              width: auto;
            }
            .enquiry-status-select.form-select {
              width: auto !important;
              min-width: 7.5rem !important;
              max-width: 9.5rem !important;
              flex: 0 0 auto !important;
            }
            .enquiry-status-submit {
              width: auto !important;
              flex: 0 0 auto !important;
            }
          }
          @media screen and (max-width: 40em) {
            .enquiry-status-actions {
              display: flex;
              flex-direction: column;
              align-items: stretch;
              justify-content: flex-end;
              width: 100%;
              gap: 8px;
            }
            .enquiry-status-select.form-select,
            .enquiry-status-submit {
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
              flex: none !important;
            }
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Enquiry Icon Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Manage Enquiries
              </h3>
              {/* <button
                onClick={() => navigate('/AddNewEnquiry')}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#223843',
                  border: 'none',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  flexShrink: 0}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Enquiry"
              >
                <ChatDots size={18} />
              </button> */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>

            {/* Add New — desktop (mobile below, match CreateAnnouncement.js) */}
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={() => navigate('/AddNewEnquiry')}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New"
              >
                <ChatDots size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Enquiry
                </span>
              </button>
         </div>

          <div className="d-md-none d-flex justify-content-end mb-4">
            <button
              type="button"
              onClick={() => navigate('/AddNewEnquiry')}
              style={{
                borderRadius: '10px',
                padding: '6px 10px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1f323a'
                e.currentTarget.style.transform = 'scale(1.03)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#223843'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Add New"
            >
              <ChatDots size={18} />
              <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                Add New Enquiry
              </span>
            </button>
          </div>

          {/* Modern Filter Section */}
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0'}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search Enquiries
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find enquiries quickly by student name, phone, or message
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                  <Row className="g-3">
                    <Col xs={12}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold text-start mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search Student Name
                        </label>
                        <div style={{ position: 'relative' }}>
                          <BsSearch 
                            style={{ 
                              position: 'absolute', 
                              left: '12px', 
                              top: '50%', 
                              transform: 'translateY(-50%)',
                              color: '#6b7280',
                              fontSize: '16px',
                              zIndex: 1}} 
                          />
                          <Form.Control
                            type="text"
                            placeholder="Enter student name..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                              paddingLeft: '40px',
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#223843'
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#D1D3D4'
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Enquiry Date</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Student Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Phone</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Message</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Enquiry By</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Status</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #E5E7EB'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {item?.created_at
                        ? new Date(item.created_at).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'})
                        : 'N/A'}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.name}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.phone}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.message}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.enquiry_by}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      <div
                        className="enquiry-status-actions"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'}}
                      >
                        <Form.Select
                          className={`form-select btn btn-sm enquiry-status-select ${
                            (statusChanges[item.id] || item.status) === 'converted'
                              ? 'btn-success'
                              : (statusChanges[item.id] || item.status) ===
                                'rejected'
                              ? 'btn-danger'
                              : 'btn-warning'
                          }`}
                          value={statusChanges[item.id] || item.status}
                          onChange={(e) =>
                            setStatusChanges((prev) => ({
                              ...prev,
                              [item.id]: e.target.value}))
                          }
                          style={{
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            // Keep space for the native dropdown arrow (btn classes override form-select padding)
                            padding: '0.25rem 2.25rem 0.25rem 0.65rem',
                            backgroundPosition: 'right 0.65rem center',
                            backgroundSize: '16px 12px',
                            appearance: 'none'}}
                        >
                          <option value="pending">Pending</option>
                          <option value="converted">Converted</option>
                          <option value="rejected">Rejected</option>
                        </Form.Select>

                        <button
                          className="btn btn-primary enquiry-status-submit"
                          onClick={async () => {
                            const updatedStatus =
                              statusChanges[item.id] || item.status

                            if (updatedStatus === 'converted') {
                              // Try converting to student
                              await handleSubmit({ ...item, status: updatedStatus })
                            }

                            if (updatedStatus === 'rejected') {
                              // REJECT FLOW (NO NAVIGATION)
                              await handleReject(item)
                              return
                            }

                            // Apply status change locally after student conversion (if needed)
                            handleStatusChange(item.id, updatedStatus)
                            // toast.success('Status updated successfully!')
                          }}
                          style={{
                            flexShrink: 0}}
                        >
                          Submit
                        </button>
                      </div>
                    </Td>

                    <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                      <div className="d-flex flex-wrap justify-content-center gap-2">
                        {/* Desktop View - Circular Button */}
                        <div className="d-none d-md-block">
                          <button
                            onClick={() => {
                              setSelectedEnquiry(item)
                              setShowEditModal(true)
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#059669'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#10B981'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Edit Enquiry"
                          >
                            <BsPencilFill size={16} />
                          </button>
                        </div>
                        {/* Mobile View - Circular Button */}
                        <div className="d-md-none d-flex justify-content-center">
                          <button
                            onClick={() => {
                              setSelectedEnquiry(item)
                              setShowEditModal(true)
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#059669'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#10B981'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Edit Enquiry"
                          >
                            <BsPencilFill size={16} />
                          </button>
                        </div>
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="7" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="enquiries"
        />
        </div>
      </div>

      <EditEnquiryForm
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        enquiry={selectedEnquiry}
        fetchEnquiries={fetchEnquiries}
      />
    </>
  )
}

export default EnquiryForm
